import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InterceptorUtil, OCC_USER_ID_ANONYMOUS, OccEndpointsService, USE_CLIENT_TOKEN } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CMSMailFormFieldListComponent, CmsMailFormFieldComponent } from '../../../../../../core/model/cms.model';

@Injectable({ providedIn: 'root' })
export class CmsMailFormFieldsConnector {
  converterService: any;
  constructor(private httpClient: HttpClient, private occEndpointsService: OccEndpointsService) {}

  /**
   * Get mailFormFields from api based on mailform field uids
   * @param userId the user id
   * @param mailFormFieldUids list of mail field uids (comma separated string e.g. 'uid01,uid02')
   */
  getCmsMailFormFields(userId: string, mailFormFieldUids: string): Observable<Array<CmsMailFormFieldComponent>> {
    let headers = new HttpHeaders();
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }
    return this.httpClient
      .get<CMSMailFormFieldListComponent>(
        this.occEndpointsService.buildUrl('mailFormFields', {
          urlParams: { userId: userId },
          queryParams: {
            uids: mailFormFieldUids,
          },
        }),
        { headers }
      )
      .pipe(map((formData) => formData.fields));
  }
}
